/* Kasutam theme — featured collection category pill tabs */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-category-tabs]').forEach(function (nav) {
      var section = nav.closest('.featured-tabs');
      if (!section) return;
      var triggers = nav.querySelectorAll('[data-tab-trigger]');
      var panels = section.querySelectorAll('[data-tab-panel]');

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var id = trigger.getAttribute('data-tab-trigger');

          triggers.forEach(function (t) {
            var active = t === trigger;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function (panel) {
            var match = panel.getAttribute('data-tab-panel') === id;
            panel.classList.toggle('is-active', match);
            panel.hidden = !match;
          });
        });
      });
    });
  });
})();
